import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemViewProcessVersionPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemViewProcessVersionProperties = {
    [name in keyof EntityCommandProcessInstanceItemViewProcessVersionPropertyValues]: Property<EntityCommandProcessInstanceItemViewProcessVersionPropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemViewProcessVersion extends IEntityCommand, EntityCommandProcessInstanceItemViewProcessVersionProperties
{
}

export class EntityCommandProcessInstanceItemViewProcessVersion extends EntityCommand implements IEntityCommandProcessInstanceItemViewProcessVersion
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemViewProcessVersion";
    public static override className = "EntityCommandProcessInstanceItemViewProcessVersion";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemViewProcessVersionPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "View Process Version",
                entityName: "ProcessInstanceItem",
                key: "VIEW_PROCESS",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }
    public static override getRequiredFields()
    {
        return [
            ...super.getRequiredFields(),
            "processInstance.processVersionId",
        ];
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemViewProcessVersionPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            record = entityCommandInformation.record.get();

        if (!record?.processInstance?.processVersionId)
            return;

        const
            ViewProcessDialog = (await import("../Ui/Dialogs/ViewProcessDialog")).ViewProcessDialog;

        ViewProcessDialog.instance
            .openAsync({
                processVersionId: record.processInstance.processVersionId,
            });
    }

    // #endregion

    // #endregion
}

